export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Destinataire :"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utilisateur non trouvé"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Contacts"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["En savoir plus"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sélection des utilisateurs"])}
}